/**
 * Site audit actions.
 * @module actions/siteAudit/siteAudit
 */

import { GET_SITE_AUDIT } from '../../constants/ActionTypes';

/**
 * Get site audit function
 * @function getSiteAudit
 * @returns {Object} Get site audit action
 */
export function getSiteAudit() {
  return {
    type: GET_SITE_AUDIT,
    request: {
      op: 'get',
      path: '/@site-audit',
    },
  };
}
